import { useUser } from '@dofleini/security';
import React from 'react';

import { MunicipalityEnumComponent } from '@/components/MunicipalityEnumComponent';

export const MunicipalityEnumByUserLevel = ({ ...rest }) => {
  const { user } = useUser();
  
  return (<MunicipalityEnumComponent province={user?.address?.province} {...rest}/>);
};

MunicipalityEnumByUserLevel.propTypes = {};
